export const ABOUT_SELLER = 'ABOUT_SELLER';
export const BUYER_INCENTIVES = 'BUYER_INCENTIVES';
export const CREATORS = 'CREATORS';
export const ITEM_DETAILS = 'ITEM_DETAILS';
export const MORE_ITEMS = 'MORE_ITEMS';
export const CUSTOMIZATION = 'CUSTOMIIZATION';
export const SHIPPING_RETURNS = 'SHIPPING_RETURNS';
export const ABOUT_THE_ITEM = 'ABOUT_THE_ITEM';
const ABOUT_THE_MAKER = 'ABOUT_THE_MAKER';

export const labelMap: Record<string, string> = {
    [MORE_ITEMS]: MORE_ITEMS,
    [ITEM_DETAILS]: ITEM_DETAILS,
    [ABOUT_SELLER]: ABOUT_SELLER,
    [BUYER_INCENTIVES]: 'The 1stDibs Promise',
    [SHIPPING_RETURNS]: SHIPPING_RETURNS,
    [CUSTOMIZATION]: CUSTOMIZATION,
    [ABOUT_THE_ITEM]: ABOUT_THE_ITEM,
    // story telling modules
    'iconic design': 'ABOUT_DESIGN',
    'seller-maker': ABOUT_THE_MAKER,
    creator: 'ABOUT_DESIGNER',
};
